import { SoundConfig } from "../../config/sound/SoundConfig";
import { SoundManager } from "../../config/sound/SoundManager";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { ReelEngineManager } from "../../../dev/reel/ReelEngineManager";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { ReelEngineController } from "../../../dev/reel/ReelEngineController";
import { ReelState } from '../../../dev/reel/ReelEngineView';
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';

export class StartPresentation extends Presentation {

    public static started:boolean = false;

    public static restoreStarted:boolean = false;

    protected addExtraForStart?(reel:ReelEngineController):void;

    preStart(): void {
        StartPresentation.started = StartPresentation.restoreStarted;
        StartPresentation.restoreStarted = false;

        if(!StartPresentation.started){
            ReelEngineManager.onBeforeSpinStart();
            ReelEngineManager.RAll((rc: ReelEngineController) => rc.createStart({ start:() => this.addExtraForStart ? this.addExtraForStart(rc) : undefined }) );
        }
    }

    createPresentation() {
        this.startReels();
        this.PresentationState.setInactive();
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining:number = ReelEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, { duration: remaining }, 0);
        return !!remaining;
    }

    startReels():void{
        if(StartPresentation.started) return;

        let delay: number = 0;
        const startReel:number = ReelEngineManager.findReelWithState(ReelState.START,true);
        ReelEngineManager.RAll(reel => {

            if(!reel.isActive) return;

            if(reel.reelID == startReel) this.timeline.add( () => {SoundManager.playSoundEffect(SoundConfig.REELS_SPINNING, Number.MAX_SAFE_INTEGER,1)}, delay);

            this.timeline.add(() => reel.startReel(), delay);

            delay += reel.startDelay;
        })

        StartPresentation.started = true;
    }
   
    skip(): void {
        RoadRageEngineManager.isQuickStop = true;
    }

    done(): void {
        Logger.logDev("Start Done");
    }

    
}